import React from "react";

const TimeLineCircle = ({ className, ...otherProps }) => (
  <div className={"circle-outline " + className} {...otherProps} />
);

export default ({ type, ...otherProps }) => (
  <TimeLineCircle className={`circle-${type}`} {...otherProps} />
);
